var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.001,
    height: 14,
    viewBox: "0 0 14.001 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pen",
    d: "M7.939,2.557l3.5,3.5-7.6,7.6L.718,14a.656.656,0,0,1-.724-.725l.347-3.123,7.6-7.6Zm5.666-.521L11.962.392a1.313,1.313,0,0,0-1.857,0L8.558,1.938l3.5,3.5,1.546-1.546a1.313,1.313,0,0,0,0-1.857Z",
    transform: "translate(0.011 -0.008)",
    fill: "#1492e6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/Edit-icon.6e0bdb3b50f768a19d44de3b5f4e846e.svg";
export { ForwardRef as ReactComponent };